import * as Yup from 'yup'


Yup.addMethod(Yup.string, "valida_patente_abc", function (errorMessage) {
    return this.test(`valida_patente_abc`, errorMessage, function (patente) {
        if (patente && patente.length > 0) {
            var regex = /^[a-z]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}|[b-d,f-h,j-l,p,r-t,v-z]{2}[\-\. ]?[b-d,f-h,j-l,p,r-t,v-z]{2}[\.\- ]?[0-9]{2}|[a-zA-Z]{2,3}[0-9]{3}|[a-zA-Z]{3}[0-9]{2}[a-zA-Z]{1}$/i;
            //var regex = /^[a-z]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}|[b-d,f-h,j-l,p,r-t,v-z]{2}[\-\. ]?[b-d,f-h,j-l,p,r-t,v-z]{2}[\.\- ]?[0-9]{2}$/i;
            if (regex.test(patente)) {
                return true;
            } else {
                return false;
            }
        }
     
        return true;
  })
})
export const validationSchemas = (isFechas,isDias, selected) => {
  
  let validationObject = { };
  
  if(isDias){
    validationObject["dias"] = Yup.string().required('Obligatorio');
   
  }
  if(isFechas){
    validationObject["tipofecha"] = Yup.string().required('Este campo es obligatorio');
    
}

if(selected==='patente'){
      

    validationObject["patente"] = Yup.string().test(
      "len",
      "La Patente no es válida",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return val.length === 0 || (val.length >= 2 && val.length <= 7);
      }
    ).valida_patente_abc("La Patente no es válida").required('Este campo es obligatorio');
  }else{
    validationObject[selected] = Yup.string().required('Este campo es obligatorio');
  }
  return Yup.object().shape(validationObject);
}

